<template>
  <!--在线客服-->
  <div class="chatbox" v-loading="loading">
    <headerbox :focus="4"></headerbox>
    <div class="chatbox1">
      <iframe src="https://tb.53kf.com/code/qrcode/daa8b04cbb02352f2449873bb79aebfa8/1" id="mobs2" scrolling="no"
              frameborder="0"></iframe>
      <!--            <iframe src="https://tb.53kf.com/code/client/624f9432c213b5185a5f8606c1299a636/1" id="mobs2"   scrolling="no" frameborder="0"></iframe>-->
      <div class="pos"></div>
    </div>
    <botbox></botbox>

    <div class="remote-assist"
         v-show="showAssistBtn"
         @click="handleAssistClick"
    >
      <img src="../../public/statics/img/chat/help@2x.png"
           class="blub-icon"
      />
      <span class="help-title">申请远程协助</span>
    </div>

    <el-form :model="assistInfo"
             :rules="assistRules"
             ref="assistInfo"
             class="remote-assist-form"
             v-show="showAssistForm"
    >
      <div class="header">
        <div class="left">
          <img src="../../public/statics/img/chat/blub.svg"
               class="blub-icon"
          />
          <span class="title">远程协助</span>
        </div>
        <img src="../../public/statics/img/chat/cross.svg"
             class="cross-icon"
             @click="handleCrossClick"
        />
      </div>
      <div class="main">
        <div class="left">
          <img src="../../public/statics/img/chat/help-bg.png"
               class="help-bg"
          />
          <div class="apply-btn"
                  @click="handleApplyClick"
          >
            申请提交
          </div>
        </div>
        <div class="form">
          <el-form-item prop="contract">
            <el-input v-model="assistInfo.contract"
                      placeholder="联系人 必填"
                      class="input-wrapper"
            />
          </el-form-item>
          <el-form-item prop="telNum">
            <el-input v-model="assistInfo.telNum"
                      placeholder="联系电话 必填"
                      class="input-wrapper"
            />
          </el-form-item>
          <el-form-item prop="coName">
            <el-input v-model="assistInfo.coName"
                      placeholder="单位名称 必填"
                      class="input-wrapper"
            />
          </el-form-item>
          <el-form-item prop="applyReason">
            <el-input type="textarea"
                      :rows="3"
                      placeholder="申请原因"
                      class="textarea-wrapper"
                      v-model="assistInfo.applyReason"
            />
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>

</template>

<script>
import headerbox from "../components/boxtop";
import botbox from "../components/botts";
import {auth} from "../request/api";

export default {
  name: "chat",
  data() {
    return {
      loading: true,
      showAssistBtn: true,
      showAssistForm: false,
      assistInfo: {
        contract: '',
        telNum: '',
        coName: '',
        applyReason: ''
      },
      assistRules: {
        contract: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
          {max: 50, message: '最多输入50个字', trigger: 'blur'}
        ],
        telNum: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {max: 15, message: '最多输入15个字', trigger: 'blur'}
        ],
        coName: [
          {required: true, message: '请输入单位名称', trigger: 'blur' },
          {max: 50, message: '最多输入50个字', trigger: 'blur'}
        ],
        applyReason: [
          {max: 255, message: '最多输入255个字', trigger: 'blur'}
        ]
      }
    }
  },
  components: {
    headerbox, botbox
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 200);
  },
  methods: {
    handleAssistClick() {
      this.showAssistForm = true
      this.showAssistBtn = false
    },

    handleCrossClick() {
      this.showAssistBtn = true
      this.showAssistForm = false
      for (let item in this.assistInfo) {
        this.assistInfo[item] = ''
      }
      this.$refs.assistInfo.resetFields()
    },

    handleApplyClick() {
      this.$refs.assistInfo.validate((valid) => {
        if(valid) {
          let url = '/v1/assistance/apply'
          let data = {
            tel_name: this.assistInfo.contract,
            telephone: this.assistInfo.telNum,
            company_name: this.assistInfo.coName,
            reason: this.assistInfo.applyReason
          }
          auth(url, data).then(res => {
            if(res.data.code == 1) {
              this.$message.success('已提交')
              this.$refs.assistInfo.resetFields()
              this.showAssistForm = false
              this.showAssistBtn = true
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    }
  },
}
</script>

<style scoped lang='scss'>
.chatbox {
  width: 100%;
  height: 100vh;
  background: #fff;
  position: relative;

  .chatbox1 {
    background: #fff;
    height: 100%;
    position: relative;

    #mobs2 {
      /*width:calc(100% - 20px);*/
      width: 100%;
      height: calc(100% - 0.5rem);
      min-height: 800px;
      box-sizing: border-box;
      margin-top: calc(0.6rem - 60px);
      /*margin-top: 0.6rem;*/
    }

    .pos {
      width: 100%;
      height: 0.6rem;
      position: fixed;
      top: 0;
      background: #1F8CEB;
    }
  }

  .remote-assist {
    position: fixed;
    right: 50px;
    bottom: 100px;
    width: 115px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #3974AB;
    border: 1px solid #FFFFFF;
    box-shadow: 5px 5px 20px rgba(72, 108, 219, 0.27);
    opacity: 1;
    border-radius: 23px;

    .blub-icon {
      width: 13.4px;
      height: 17.7px;
      margin-right: 8px;
    }

    .help-title {
      font-size: 13px;
      font-weight: bold;
      color: #fff;
    }
  }

  .remote-assist:hover {
    cursor: pointer;
  }

  .remote-assist-form {
    position: fixed;
    right: 50px;
    bottom: 100px;
    width: 400px;
    height: auto;
    background: #FFFFFF;
    border: 1px solid #F8F8F8;
    box-shadow: 0px 5px 20px rgba(210, 210, 219, 0.34);
    opacity: 1;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 10px;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        align-items: center;

        .blub-icon {
          width: calc(18px / 1.3);
          height: 18px;
          margin-right: 10px;
        }

        .title {
          font-size: 14px;
          font-family: "PingFang SC";
          font-weight: bold;
          color: #3974ab;
        }
      }

      .cross-icon {
        width: 10px;
        height: 10px;
      }

      .cross-icon:hover {
        cursor: pointer;
      }
    }

    .main {
      display: flex;

      .left {
        display: flex;
        flex-direction: column;
        align-items: center;

        .help-bg {
          margin-top: 26px;
          width: 168px;
          height: 113px;
        }

        .apply-btn {
          width: 83px;
          height: 21px;
          line-height: 21px;
          margin-top: 70px;
          border: none;
          background: #3974AB;
          opacity: 1;
          border-radius: 13px;
          font-size: 10px;
          font-weight: bold;
          color: #fff;
        }

        .apply-btn {
          cursor: pointer;
        }
      }

      .form {
        font-family: "PingFang SC";
        font-weight: bold;
        margin-top: 10px;
        font-size: 13px;

        /deep/ .el-form-item__content {
          line-height: 24px;
        }

        .input-wrapper {

          /deep/ .el-input__inner {
            height: 24px;
            background: #f9f9f9;
            font-size: 13px;
          }

          /deep/ .el-input__inner::placeholder {
            color: #A1BCD5;
            font-size: 13px;
          }
        }

        /deep/ .el-input {
          height: 24px;
        }

        .textarea-wrapper {
          width: 192px;
          height: 79px;

          /deep/ .el-textarea__inner {
            height: 79px;
            background: #f9f9f9;
            font-size: 13px;
          }

          /deep/ .el-textarea__inner::placeholder {
            color: #A1BCD5;
            font-size: 13px;
          }
        }
      }
    }
  }

}
</style>
<style lang="scss">
#dokuwiki__header {
  display: none !important;
}

/*.headings .group{*/
/*    display: none!important;*/
/*}*/
.close-suc font12 {
  display: none;
}
</style>
